// Demo Users for Authentication
export const demoUsers = {
  superAdmin: {
    id: 'sa-001',
    email: 'admin@forwardsflow.com',
    password: 'admin123',
    name: 'System Administrator',
    role: 'forwardsflow_admin',
    createdAt: '2024-01-15T10:00:00Z',
    lastLogin: new Date().toISOString(),
  },
  bankAdmin: {
    id: 'ba-001',
    email: 'admin@equityafrica.com',
    password: 'demo123',
    name: 'Amoroso Gombe',
    role: 'bank_admin',
    tenantType: 'bank',
    tenantId: 'bank-001',
    tenantName: 'Equity Africa Bank',
    jobRole: 'Treasury Director',
    createdAt: '2024-02-10T09:00:00Z',
  },
  complianceMaker: {
    id: 'cm-001',
    email: 'compliance@equityafrica.com',
    password: 'demo123',
    name: 'Sarah Kimani',
    role: 'bank_compliance_maker',
    tenantType: 'bank',
    tenantId: 'bank-001',
    tenantName: 'Equity Africa Bank',
    jobRole: 'Compliance Officer',
    createdAt: '2024-03-01T09:00:00Z',
  },
  complianceChecker: {
    id: 'cc-001',
    email: 'checker@equityafrica.com',
    password: 'demo123',
    name: 'Faith Wanjiku',
    role: 'bank_compliance_checker',
    tenantType: 'bank',
    tenantId: 'bank-001',
    tenantName: 'Equity Africa Bank',
    jobRole: 'Compliance Checker',
    createdAt: '2024-03-15T09:00:00Z',
  },
  treasuryDealer: {
    id: 'td-001',
    email: 'fx@equityafrica.com',
    password: 'demo123',
    name: 'Grace Mwangi',
    role: 'bank_treasury_dealer',
    tenantType: 'bank',
    tenantId: 'bank-001',
    tenantName: 'Equity Africa Bank',
    jobRole: 'Foreign Exchange Spot Dealer',
    createdAt: '2024-04-01T08:00:00Z',
  },
  forwardsDealer: {
    id: 'fd-001',
    email: 'forwards@equityafrica.com',
    password: 'demo123',
    name: 'David Kariuki',
    role: 'bank_forwards_dealer',
    tenantType: 'bank',
    tenantId: 'bank-001',
    tenantName: 'Equity Africa Bank',
    jobRole: 'Foreign Exchange Forwards Dealer',
    createdAt: '2024-07-15T09:00:00Z',
  },
  familyOffice: {
    id: 'fo-001',
    email: 'admin@horizonimpact.com',
    password: 'demo123',
    name: 'Victoria Chen',
    role: 'investor_family_office',
    tenantType: 'investor',
    tenantId: 'inv-001',
    tenantName: 'Horizon Impact Partners',
    jobRole: 'Family Office Director',
    createdAt: '2024-03-20T14:00:00Z',
  },
  individual: {
    id: 'ii-001',
    email: 'analyst@horizonimpact.com',
    password: 'demo123',
    name: 'James Okonkwo',
    role: 'investor_individual',
    tenantType: 'investor',
    tenantId: 'inv-001',
    tenantName: 'Horizon Impact Partners',
    jobRole: 'Individual Investor',
    createdAt: '2024-05-15T11:00:00Z',
  },
};

// Demo Tenants
export const demoTenants = {
  investors: [
    {
      id: 'inv-001',
      name: 'Horizon Impact Partners',
      type: 'Investment Fund',
      country: 'United Kingdom',
      aum: 850000000,
      moodysRating: 'Aa2',
      status: 'active',
      createdAt: '2024-03-20T14:00:00Z',
    },
    {
      id: 'inv-002',
      name: 'Atlas Growth Capital',
      type: 'Private Equity',
      country: 'United States',
      aum: 1200000000,
      moodysRating: 'Aa3',
      status: 'active',
      createdAt: '2024-04-10T10:00:00Z',
    },
  ],
  banks: [
    {
      id: 'bank-001',
      name: 'Equity Africa Bank',
      type: 'Commercial Bank',
      country: 'Kenya',
      capitalAdequacy: 18.2,
      moodysRating: 'A+',
      status: 'active',
      createdAt: '2024-02-10T09:00:00Z',
    },
    {
      id: 'bank-002',
      name: 'Diamond Trust Bank',
      type: 'Commercial Bank',
      country: 'Kenya',
      capitalAdequacy: 16.8,
      moodysRating: 'A',
      status: 'active',
      createdAt: '2024-02-15T11:00:00Z',
    },
    {
      id: 'bank-003',
      name: 'KCB Group',
      type: 'Commercial Bank',
      country: 'Kenya',
      capitalAdequacy: 19.5,
      moodysRating: 'A+',
      status: 'active',
      createdAt: '2024-07-01T09:00:00Z',
    },
  ],
};

export const institutionTypes = [
  { value: 'commercial_bank', label: 'Commercial Bank' },
  { value: 'microfinance_bank', label: 'Microfinance Bank' },
  { value: 'mfi', label: 'Microfinance Institution (MFI)' },
  { value: 'sacco', label: 'SACCO / Credit Union' },
  { value: 'digital_bank', label: 'Digital / Neobank' },
  { value: 'dfi', label: 'Development Finance Institution (DFI)' },
  { value: 'other', label: 'Other Financial Institution' }
];

export const investorTypes = [
  { value: 'impact_fund', label: 'Impact Investment Fund' },
  { value: 'private_equity', label: 'Private Equity Firm' },
  { value: 'family_office', label: 'Family Office' },
  { value: 'dfi', label: 'Development Finance Institution (DFI)' },
  { value: 'asset_manager', label: 'Institutional Asset Manager' },
  { value: 'pension_fund', label: 'Pension / Sovereign Fund' },
  { value: 'other', label: 'Other Institutional Investor' }
];

export const countries = [
  { value: 'Kenya', label: 'Kenya' },
  { value: 'India', label: 'India' },
  { value: 'Brazil', label: 'Brazil' },
  { value: 'Mexico', label: 'Mexico' },
  { value: 'Turkey', label: 'Turkey' },
  { value: 'Bangladesh', label: 'Bangladesh' },
  { value: 'South Africa', label: 'South Africa' },
  { value: 'Egypt', label: 'Egypt' },
  { value: 'Ethiopia', label: 'Ethiopia' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'United States', label: 'United States' },
  { value: 'Switzerland', label: 'Switzerland' },
  { value: 'United Arab Emirates', label: 'United Arab Emirates' },
  { value: 'Japan', label: 'Japan' }
];

export const currencies = [
  { value: 'USD', label: 'USD - US Dollar' },
  { value: 'CHF', label: 'CHF - Swiss Franc' },
  { value: 'AED', label: 'AED - UAE Dirham' },
  { value: 'GBP', label: 'GBP - British Pound' },
  { value: 'JPY', label: 'JPY - Japanese Yen' },
  { value: 'KES', label: 'KES - Kenyan Shilling' }
];

export const moodysRatings = [
  { value: 'Aaa', label: 'Aaa - Highest Quality' },
  { value: 'Aa1', label: 'Aa1 - High Quality' },
  { value: 'Aa2', label: 'Aa2 - High Quality' },
  { value: 'Aa3', label: 'Aa3 - High Quality' },
  { value: 'A1', label: 'A1 - Upper-Medium Grade' },
  { value: 'A2', label: 'A2 - Upper-Medium Grade' },
  { value: 'A3', label: 'A3 - Upper-Medium Grade' },
  { value: 'Baa1', label: 'Baa1 - Medium Grade' }
];

export const investmentTerms = [
  { value: '1_month', label: '1 Month' },
  { value: '3_months', label: '3 Months' },
  { value: '6_months', label: '6 Months' },
  { value: '12_months', label: '12 Months' },
  { value: '24_months', label: '24 Months' }
];
